var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3333 15.9998C29.3333 23.3636 23.3638 29.3332 16 29.3332C8.63616 29.3332 2.66663 23.3636 2.66663 15.9998C2.66663 8.63604 8.63616 2.6665 16 2.6665C23.3638 2.6665 29.3333 8.63604 29.3333 15.9998ZM26.6666 15.9998C26.6666 21.8909 21.891 26.6665 16 26.6665C10.1089 26.6665 5.33329 21.8909 5.33329 15.9998C5.33329 10.1088 10.1089 5.33317 16 5.33317C19.1442 5.33317 21.9707 6.6936 23.9229 8.85794L14.6666 18.1142L10.9428 14.3904C10.4221 13.8697 9.57785 13.8697 9.05715 14.3904C8.53645 14.9111 8.53645 15.7553 9.05715 16.276L12.781 19.9998C13.8224 21.0412 15.5108 21.0412 16.5522 19.9998L25.4686 11.0835C26.234 12.5547 26.6666 14.2268 26.6666 15.9998Z",
    fill: "#4D8F65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToastIcon);
export default __webpack_public_path__ + "static/media/success_toast_icon.ae787d61282e6239e22d883a660fad09.svg";
export { ForwardRef as ReactComponent };